require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-mattersburg-zemendorf-stoettera.json") })
        }
      }, "path---betreuungseinrichtungen-mattersburg-zemendorf-stoettera");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-mattersburg-zemendorf-stoettera!./.cache/json/betreuungseinrichtungen-mattersburg-zemendorf-stoettera.json
// module id = 941
// module chunks = 231608221292675